import { createUseStyles } from '@glu/theming';

export const styles = ({ spacing: { unit } }) => ({
  workspace: {
    display: 'flex',
    flexFlow: 'row wrap',
    padding: `0 ${unit * 7.5}px ${unit * 7.5}px`
  },
  locked: {
    paddingTop: unit * 3.75
  },
  changePasswordStyles: {
    '&.btn.btn-tertiary': {
      padding: 0,
      marginLeft: 0.5 * unit
    }
  },
  passwordExpirationAlertStyles: {
    display: 'flex',
    alignItems: 'center'
  }
});

export default createUseStyles(styles);
